import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = articles.slice(4, 9);

  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              新鲜出炉 / <span className="text-primary-500">全网吃瓜</span>
            </h2>
            <span className="px-3 py-1.5 rounded-full bg-secondary-500 text-background-50 text-xs font-label whitespace-nowrap">
              实时更新
            </span>
          </div>

          <div className="flex overflow-x-auto gap-5 pb-4 -mx-4 px-4 scrollbar-hide">
            {latestArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="flex-shrink-0 w-72 group cursor-pointer"
              >
                <div className="bg-background-50 rounded-lg overflow-hidden">
                  <div className="aspect-square overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4">
                    <span className="text-xs text-foreground-500">{article.category}</span>
                    <p className="text-sm text-foreground-800 mt-1 line-clamp-2 leading-snug">
                      {article.excerpt}
                    </p>
                    <div className="mt-3">
                      <span className="text-xl font-heading font-bold text-foreground-950">
                        {article.readCount > 100000
                          ? `${(article.readCount / 10000).toFixed(1)}万`
                          : article.readCount}
                      </span>
                      <span className="text-xs text-foreground-400 ml-1">热度</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
            <div className="flex-shrink-0 w-8"></div>
          </div>
        </div>
      </div>
    </section>
  );
}